export default __webpack_public_path__ + "static/media/IMG_0025_6_11zon.3d59849e.jpg";